import { map } from "rxjs/operators";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";


@Component({
  selector: 'app-bar-affection-produit',
  templateUrl: './bar-affection-produit.component.html',
  styleUrls: ['./bar-affection-produit.component.scss']
})
export class BarAffectionProduitComponent implements OnInit {

defaultValues: any = {};
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  @Input() currentProduit: any;
  @Input() currentBareme: any;
  @Output() onChangeAffectionBaremeForm = new EventEmitter<any>();
  user: any;
  clearText:boolean=true
  filiale_id: any;
  gender: string;
  createMessage: string;
  title: string;
  is_all_checked: boolean;
  editMessage: string;
  itemsTypeRemboursement: any = [];
  currentData: any;
  current_produit_id: any;
  indiceTab: number;
  itemToAddTrancheAge: any = {};
  itemsPrimeByTrancheAge: any = [];
  itemToAddStatutTrancheAge: any;
  itemsPrimeByStatutAndTrancheAge: any = [];
  searchKey: any;
  currentPage: number = 0;
  itemsPerPage: number = 30;
  busyGet: Subscription;
  totalItems: any;
  itemsAffectionProduit: any = [];
  itemsAffectionProduitBareme: any = [];
  itemsChecked: any = [];
  itemsStatut: any=[];
  itemToAdd: any={};
  itemsAutorisation=[
    {code:'is_pc',libelle:'Couvert'},
    // {code:'is_entente_prealable',libelle:'Soumis à entente préalable'},
    {code:'is_exclu',libelle:'Exclu'},
  ]

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.itemToSave.plafond_annuel_famille = 0;
    this.itemToSave.prime_par_famille = 0;

    // this.itemToSave.mode_reconduction_id=''

    // setTimeout(() => {
    //   console.log("here");
    //   // this.itemToSave.date_effet = new Date()
    //   // this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
    //   if (this.currentData) {
    //     console.log("currentData: ", this.currentData);

    //     this.itemToSave = Object.assign({}, this.currentData);
    //     this.current_produit_id = this.itemToSave.id;
    //     this.getItemsAffectionProduit();
    //   }
    // }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in form prime tranche age statut: ", changes);
    this.itemsChecked = []
    const keysToClear = ["type_remboursement_id", "plafond_famille", "plafond_individuel", "is_checked"];

    this.items.forEach(item => {
      keysToClear.forEach(key => item[key] = null); // Set to null
    });
    if (
      changes && changes.currentBareme &&
      changes.currentBareme.currentValue && changes.currentBareme.currentValue.id &&
      changes.currentProduit && changes.currentProduit.currentValue
    ) {
      this.getItemsAffectionProduitBareme();

    }
    else {
      this.getItemsAffectionProduit();

    }
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
    this.itemToAddTrancheAge.age_min = 0;
    if (this.itemsPrimeByTrancheAge && this.itemsPrimeByTrancheAge > 0) {
      this.itemToAddTrancheAge.age_min =
        Math.min(...this.itemsPrimeByTrancheAge.map((r) => r.age_max)) + 1;
    }

    this.itemToAddStatutTrancheAge.age_min = 0;
    if (
      this.itemsPrimeByStatutAndTrancheAge &&
      this.itemsPrimeByStatutAndTrancheAge > 0
    ) {
      this.itemToAddStatutTrancheAge.age_min =
        Math.min(
          ...this.itemsPrimeByStatutAndTrancheAge.map((r) => r.age_max)
        ) + 1;
    }
    // this.itemtad
  }


  getItemsAffectionProduitBareme() {
    if (!this.currentBareme.id) {
      this.getItemsAffectionProduit();
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        bareme_id: this.currentBareme.id
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("affectionProduitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          // this.getItems();
          if (res && res["items"] && !res["hasError"]) {
            this.itemsAffectionProduitBareme = res["items"];
            this.onChangeAffectionBaremeForm.emit(this.itemsAffectionProduitBareme)
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsAffectionProduitBareme = [];
          }
        },
        (err) => {
          this.itemsAffectionProduitBareme = [];
        }
      );
  }
  getItemsAffectionProduit() {
    if (!this.currentProduit.id) {
      return;
    }
    if (this.currentBareme.id) {
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        produit_id: this.currentProduit.id,
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("affectionProduit/getByCriteria", request)
      .subscribe(
        (res) => {
          // this.getItems();
          if (res && res["items"] && !res["hasError"]) {
            this.itemsAffectionProduitBareme = res["items"];
            this.onChangeAffectionBaremeForm.emit(this.itemsAffectionProduitBareme)

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsAffectionProduitBareme = [];
          }
        },
        (err) => {
          this.itemsAffectionProduitBareme = [];
        }
      );
  }



  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return (
      desiredOrder.indexOf(a.codification) -
      desiredOrder.indexOf(b.codification)
    );
  }




  getItemsStatut() {
      let request = {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {},
      };
  
      this.busyGet = this.restClient
        .post("statut/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
              
              this.itemsStatut.sort((a, b) => this.customSort(a, b));
  
            } else {
              this.itemsStatut = [];
            }
          },
          (err) => {
            this.itemsStatut = [];
          }
        );
    }

     customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }
  onSelectAffection(event){
    if(!event){
      return
    }
    console.log('affection: ',event)
    this.itemToAdd.affection_id = event.id
    this.itemToAdd.affection_libelle = event.libelle
  }
  addItemToList(){
    if(!this.itemToAdd.affection_id){
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner affection svp !",
        "bottom",
        "center"
      );
      return
    }
    if(!this.itemToAdd.statut_id){
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner statut svp !",
        "bottom",
        "center"
      );
      return
    }

    let isExist = false
    if(this.itemsAffectionProduitBareme && this.itemsAffectionProduitBareme.length){
      isExist = !!this.itemsAffectionProduitBareme.filter(it=>it.affection_id == this.itemToAdd.affection_id && it.statut_id == this.itemToAdd.statut_id ).length
    }

    if(!isExist){
      this.itemToAdd.statut_libelle = this.itemsStatut.find((is:any)=>is.id==this.itemToAdd.statut_id).libelle
      if(this.itemToAdd.autorisation == 'is_pc'){
        this.itemToAdd.is_pc=true
        this.itemToAdd.is_exclu=false
      }
      if(this.itemToAdd.autorisation == 'is_exclu'){
        this.itemToAdd.is_exclu=true
        this.itemToAdd.is_pc=false

      }
      this.itemsAffectionProduitBareme.push(this.itemToAdd)
      this.onChangeAffectionBaremeForm.emit(this.itemsAffectionProduitBareme);
      this.itemToAdd = {}
    }
    else{
      this.utilities.showNotification(
        "snackbar-danger",
        "Cette combinaison existe deja dans la liste !",
        "bottom",
        "center"
      );
    }
  }


  onDelete(indice){
    this.itemsAffectionProduit.splice(indice,1)
    this.onChangeAffectionBaremeForm.emit(this.itemsAffectionProduit);


  }
  ngOnInit() {
    this.getItemsStatut()
  }

}
